import React from 'react';
// import LanguageSwitcher from '../../shared-components/LanguageSwitcher';

const ToolbarLayoutAdmin = ({ adminPage = false }: { adminPage: boolean }) => {
	return <></>;
};

export default React.memo(ToolbarLayoutAdmin);
